<template>
  <div>
    <taxon-item
      :key="`taxon-item-${index}`"
      v-for="(item, index) in visibleItems"
      v-bind="item"
    ></taxon-item>
    <button
      v-if="hasManyItems"
      @click="isOpen = !isOpen"
      class="btn btn-sm btn-primary-link ml-n1 mt-1"
    >
      {{ isOpen ? t.show_less : t.show_more }}
    </button>
  </div>
</template>

<script>
import TaxonItem from "./TaxonItem";
export default {
  name: "FilterWrapper",
  components: {
    TaxonItem,
  },
  props: {
    items: {
      required: true,
      type: Array,
    },
    t: {
      type: Object,
      required: true,
    },
    maxVisible: {
      required: false,
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      isOpen: false,
      hasManyItems: this.items ? this.items.length > this.maxVisible : false,
    };
  },
  computed: {
    visibleItems() {
      if (!this.items) return null;
      return this.items.slice(0, this.isOpen ? this.items.length : this.maxVisible);
    },
  },
};
</script>
